export default "__VITE_ASSET__Dipvu6_N__"